/**
 * WordPress dependencies
 */
import { registerPlugin } from '@safe-wordpress/plugins';

/**
 * Internal dependencies
 */
import { FormEditorExtensions } from './components';
import './style.scss';

registerPlugin( 'nelio-forms-extensions', {
	icon: () => null,
	render: FormEditorExtensions,
} );
